import { isEqual } from 'lodash';
import Head from 'next/head';
import React from 'react';
import { HTTP_RESPONSE_CODES } from '../../common/helpers/constants';
import AdvertiseUs from '../../components/footerPage/advertiseUs/AdvertiseUs';
import ContactUs from '../../components/footerPage/contactUs/ContactUs';
import {
  PageWrapper,
  TextContentWrapper,
} from '../../components/pages/footerPage/FooterPage.style';
import Page from '../../layouts/main';
import { fetchFooterContent, FooterPageData } from '../../services/common';
import Error from '../_error';
import { CustomNextPageContext } from '../../lib/customNextPageContext';

const CONTACT_US_SLUG = 'contact-us';
const ADVERTISE_WITH_US_SLUG = 'advertise-with-us';
const JOBS_SLUG = 'jobs';
const NEW_JOBS_SLUG = 'รับสมัครงาน';

interface FooterPageProps {
  data: FooterPageData | null;
  slug: string;
}

function FooterPage({ data, slug }: FooterPageProps) {
  const id = data?.id;
  if (!id) {
    return <Error statusCode={HTTP_RESPONSE_CODES.NotFound} />;
  }

  const { title, content } = data;
  return (
    <Page>
      <Head>
        <title>{title}</title>
      </Head>
      <PageWrapper>
        <TextContentWrapper>
          <div
            data-test="title"
            className="title"
            dangerouslySetInnerHTML={{ __html: title }}
          />
          <div
            data-test="content"
            className="content"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </TextContentWrapper>
        {slug === CONTACT_US_SLUG && <ContactUs />}
        {slug === ADVERTISE_WITH_US_SLUG && <AdvertiseUs />}
      </PageWrapper>
    </Page>
  );
}

FooterPage.getInitialProps = async ({
  query,
  apolloClient,
}: CustomNextPageContext) => {
  let slug = encodeURIComponent(query.slug as string);

  if (isEqual(slug, encodeURIComponent(NEW_JOBS_SLUG))) {
    slug = JOBS_SLUG;
  }

  const data = await fetchFooterContent(apolloClient, {
    slug,
  });

  return {
    data,
    slug,
  };
};

export default FooterPage;
